import { Instagram, Facebook, MessageCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

const LOGO_MARK = "https://customer-assets.emergentagent.com/job_5c120cb0-6c39-4574-8992-e03c5cf62daa/artifacts/9e7hexs6_logo-ed-removebg-preview.png";

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.getSettings().then(setSettings).catch(console.error);
  }, []);

  const socialLinks = settings?.social_links || {};

  return (
    <footer className="bg-card border-t border-border transition-theme">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center gap-4">
            {/* <img 
              src={LOGO_MARK} 
              alt="ED" 
              className="h-12 w-auto opacity-80"
            /> */}
            <div>
              <p className="font-serif text-lg">Eddy Dossou</p>
              <p className="text-xs text-muted-foreground tracking-widest uppercase">Photographe</p>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            {socialLinks.instagram && (
              <a 
                href={socialLinks.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            )}
            {socialLinks.facebook && (
              <a 
                href={socialLinks.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            )}
            {socialLinks.tiktok && (
              <a 
                href={socialLinks.tiktok} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="TikTok"
                data-testid="footer-tiktok"
              >
                <TikTokIcon className="h-5 w-5" />
              </a>
            )}
            {socialLinks.whatsapp && (
              <a 
                href={`https://wa.me/${socialLinks.whatsapp.replace(/\D/g, '')}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="WhatsApp"
                data-testid="footer-whatsapp"
              >
                <MessageCircle className="h-5 w-5" />
              </a>
            )}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-border/40 text-center">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Eddy Dossou. Tous droits réservés.
          </p>
          <a href="https://www.jokast38.fr" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            par Jokast Kassa
          </a>
        </div>
      </div>
    </footer>
  );
}
